module.exports = __webpack_public_path__ + "static/media/cluser.a0c8b8ec.svg";